// extracted by mini-css-extract-plugin
export default {"content":"NghviD","title":"n0ipiM","topTarget":"Ou_kH5"};